'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useTheme, styled } from '@classify/react-core-components/styles';
import ContentWrapper from '@classify/react-core-components/ContentWrapper';
import Section from '@classify/react-core-components/Section';
import Narrative from '@classify/react-marketing-components/Narrative';
import { NarrativeMediaContainer } from '@classify/react-marketing-components/NarrativeMediaContainer';
import Intro from './Intro';
import Quote from './Quote';
import type { Step } from '../../_services/getSteps';
const VideoWrapper = styled('div')(({
  theme: {
    spacing
  }
}) => ({
  marginTop: spacing(3),
  '& iframe': {
    maxWidth: 646,
    aspectRatio: '16 / 9',
    border: 'none'
  }
}));
const StepNarrative = styled(Narrative, {
  shouldForwardProp: prop => !['isEven'].includes(prop as string)
})<{
  isEven: boolean;
}>(({
  theme: {
    breakpoints
  },
  isEven
}) => ({
  [breakpoints.up('xs')]: {
    flexDirection: 'column-reverse'
  },
  [breakpoints.up('md')]: {
    flexDirection: isEven ? 'row' : 'row-reverse'
  }
}));
interface StepProps {
  step: Step;
  activeLang: string;
}
const Step = t0 => {
  const $ = _c(34);
  const {
    step,
    activeLang
  } = t0;
  const {
    title,
    order,
    video,
    videoTitle,
    slug
  } = step;
  const {
    palette
  } = useTheme();
  const isEven = order % 2 === 0;
  const customColor = isEven ? palette.content.highlight.firstLevel.background : palette.content.highlight.secondLevel.background;
  let t1;
  if ($[0] !== step.illustrationSrc) {
    t1 = <NarrativeMediaContainer><Image src={step.illustrationSrc} alt="" width={289} height={289} /></NarrativeMediaContainer>;
    $[0] = step.illustrationSrc;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== order || $[3] !== step.intro || $[4] !== title) {
    t2 = <Intro title={title} intro={step.intro} order={order} />;
    $[2] = order;
    $[3] = step.intro;
    $[4] = title;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== step.description || $[7] !== step.quote || $[8] !== step.status || $[9] !== step.testimonialPictureSrc) {
    t3 = <Quote quote={step.quote} testimonialPictureSrc={step.testimonialPictureSrc} description={step.description} status={step.status} />;
    $[6] = step.description;
    $[7] = step.quote;
    $[8] = step.status;
    $[9] = step.testimonialPictureSrc;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = video[activeLang];
  let t5;
  if ($[11] !== t4 || $[12] !== videoTitle) {
    t5 = <VideoWrapper><iframe title={videoTitle} src={t4} allowFullScreen={true} /></VideoWrapper>;
    $[11] = t4;
    $[12] = videoTitle;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== step.services) {
    t6 = step.services && <step.services />;
    $[14] = step.services;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t2 || $[17] !== t3 || $[18] !== t5 || $[19] !== t6) {
    t7 = <div>{t2}{t3}{t5}{t6}</div>;
    $[16] = t2;
    $[17] = t3;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== isEven || $[22] !== t1 || $[23] !== t7) {
    t8 = <StepNarrative isEven={isEven} media={t1}>{t7}</StepNarrative>;
    $[21] = isEven;
    $[22] = t1;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== step.additionalContent) {
    t9 = step.additionalContent && <step.additionalContent />;
    $[25] = step.additionalContent;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t8 || $[28] !== t9) {
    t10 = <ContentWrapper>{t8}{t9}</ContentWrapper>;
    $[27] = t8;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== customColor || $[31] !== slug || $[32] !== t10) {
    t11 = <Section variant="marketing" customColor={customColor} id={slug}>{t10}</Section>;
    $[30] = customColor;
    $[31] = slug;
    $[32] = t10;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  return t11;
};
export default Step;